const url = (base, memberId, historyId) => `${base.replace(/\/$/, '')}/identity/members/${encodeURIComponent(memberId)}/status/${encodeURIComponent(historyId)}/documents`;
async function check(r) {
    if (!r.ok) {
        const body = await r.json().catch(() => null);
        throw new Error(body?.message ?? 'No pudimos procesar la constancia.');
    }
    return r;
}
async function metadata(r) {
    const data = await (await check(r)).json();
    if (!data ||
        !Array.isArray(data.documents) ||
        !data.documents.every((d) => typeof d.id === 'string' &&
            typeof d.fileName === 'string' &&
            typeof d.sizeBytes === 'number' &&
            typeof d.uploadedAt === 'string'))
        throw new Error('Respuesta documental inválida.');
    return data;
}
export async function getResignationDocuments(base, memberId, historyId, signal) {
    return metadata(await fetch(url(base, memberId, historyId), { credentials: 'include', signal: signal ?? null }));
}
export async function uploadResignationDocument(base, memberId, historyId, file) {
    return metadata(await fetch(url(base, memberId, historyId), {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/pdf',
            'x-urbanik-file-name': encodeURIComponent(file.name),
        },
        body: file,
    }));
}
export async function downloadResignationDocument(base, memberId, historyId, id) {
    return (await check(await fetch(url(base, memberId, historyId) + '/' + encodeURIComponent(id), {
        credentials: 'include',
    }))).blob();
}
export async function changeResignationDocument(base, memberId, historyId, id, reason, file) {
    return metadata(await fetch(url(base, memberId, historyId) + '/' + encodeURIComponent(id), {
        method: file ? 'PUT' : 'DELETE',
        credentials: 'include',
        headers: file
            ? {
                'Content-Type': 'application/pdf',
                'x-urbanik-file-name': encodeURIComponent(file.name),
                'x-urbanik-reason': encodeURIComponent(reason),
            }
            : { 'Content-Type': 'application/json' },
        body: file ?? JSON.stringify({ reason }),
    }));
}
